module.exports = __webpack_public_path__ + "static/img/OHSAS18001_Renwu_3.f7afe473.jpg";